export default function TechTag({ technology }) {
  return (
    <span className="px-3 py-1 bg-emerald-600/30 text-emerald-200 rounded-full text-xs border border-emerald-400/20">
      {technology}
    </span>
  );
}